import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";

// Fallback set matches the seven iter17 defaults so the app has sensible
// meta before the first /task-statuses response lands.
export const STATUS_FALLBACK = {
  todo:        { label: "To do",       color: "#94A3B8", bg: "rgba(148,163,184,0.15)" },
  in_progress: { label: "In progress", color: "#38BDF8", bg: "rgba(56,189,248,0.15)" },
  in_review:   { label: "In review",   color: "#A78BFA", bg: "rgba(167,139,250,0.15)" },
  blocked:     { label: "Blocked",     color: "#F87171", bg: "rgba(248,113,113,0.15)" },
  on_hold:     { label: "On hold",     color: "#FBBF24", bg: "rgba(251,191,36,0.15)" },
  done:        { label: "Done",        color: "#25D366", bg: "rgba(37,211,102,0.15)" },
  cancelled:   { label: "Cancelled",   color: "#6B7280", bg: "rgba(107,114,128,0.15)" },
};

function hexToRgba(hex, alpha = 0.15) {
  if (!hex || !hex.startsWith("#") || hex.length < 7) return `rgba(148,163,184,${alpha})`;
  const r = parseInt(hex.slice(1, 3), 16), g = parseInt(hex.slice(3, 5), 16), b = parseInt(hex.slice(5, 7), 16);
  return `rgba(${r},${g},${b},${alpha})`;
}

/**
 * Shared hook — returns the division's task-status set (custom + defaults),
 * plus a lookup map with `{label, color, bg, is_terminal}` for badges.
 * Used by Projects timeline, DealDetail tasks, and any future task UI.
 */
export function useTaskStatuses() {
  const { data = [], isLoading } = useQuery({
    queryKey: ["task-statuses"],
    queryFn: () => api.get("/task-statuses").then((r) => r.data),
    staleTime: 5 * 60 * 1000,
  });
  const meta = { ...STATUS_FALLBACK };
  for (const s of data) {
    meta[s.key] = { label: s.label, color: s.color || "#94A3B8", bg: hexToRgba(s.color), is_terminal: s.is_terminal };
  }
  const list = data.length
    ? data
    : Object.entries(STATUS_FALLBACK).map(([k, v]) => ({ key: k, label: v.label, color: v.color, is_terminal: k === "done" || k === "cancelled" }));
  return { meta, list, isLoading };
}
